// extracted by mini-css-extract-plugin
export default {"formErrorMessage":"referal_formErrorMessage__2P568"};